import { SPARKL } from '../../consts/constants';
import { HALE_MOBILE } from './hale.config';
import { getActiveBrandKey } from './resolveBrand';
import { BrandKey } from './types';

export { HALE_MOBILE };

export interface BrandContactInfo {
  mobile: string;
  mobileDial: string;
  email: string;
}

const toDialNumber = (phone: string): string => phone.replace(/\s/g, '');

export const getBrandContactInfo = (
  brandKey?: BrandKey | null,
): BrandContactInfo => {
  const key = brandKey ?? getActiveBrandKey();

  if (key === 'hale') {
    return {
      mobile: HALE_MOBILE,
      mobileDial: toDialNumber(HALE_MOBILE),
      email: SPARKL.email,
    };
  }

  return {
    mobile: SPARKL.mobile,
    mobileDial: SPARKL.mobile,
    email: SPARKL.email,
  };
};
